import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import cx from "classnames";
import { Input } from "../Input";
import { FieldLabel } from "../FieldLabel";
import { FieldDescription } from "../FieldDescription";
import styles from "./TextFieldType.less";
export var TextFieldType =
/*#__PURE__*/
function (_Component) {
  _inherits(TextFieldType, _Component);

  function TextFieldType() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextFieldType);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextFieldType)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (evt) {
      var value = evt.target.value;
      var name = evt.target.name;

      if (_this.props.onChange) {
        _this.props.onChange(name, value, _this.props.datatype);
      }
    });

    return _this;
  }

  _createClass(TextFieldType, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.name) {
        throw new Error('Missing required attribute "name". See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var valueLength = this.props.value && this.props.value.length ? this.props.value.length : 0;
      var maxLength = this.props.maxLength ? this.props.maxLength : 150;
      return React.createElement("label", {
        ref: this.props.innerRef,
        className: cx(styles.TextFieldType, this.props.className, valueLength > maxLength ? styles.Error : "")
      }, React.createElement(FieldLabel, {
        label: this.props.label,
        required: this.props.required,
        tag: this.props.tag,
        maxLength: maxLength,
        valueLength: valueLength,
        tooltip: this.props.tooltip
      }), React.createElement(Input, {
        type: "text",
        name: this.props.name,
        value: this.props.value,
        placeholder: this.props.placeholder,
        required: this.props.required,
        autoFocus: this.props.autofocus,
        onChange: this.onChange,
        disabled: this.props.disabled,
        error: this.props.error
      }), valueLength > maxLength && React.createElement("span", {
        className: styles.ErrorDescription
      }, "Your input is over the specified limit"), React.createElement(FieldDescription, {
        description: this.props.description
      }));
    }
  }]);

  return TextFieldType;
}(Component);